(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });
  // Open the legal notice image in the theme modal instead of jumping to #legal-notice
  document.addEventListener('click', (evt) => {
    const trigger = evt.target.closest('a[href="#legal-notice"], a[href$="#legal-notice"]');
    if (!trigger) return;

    const modal = document.getElementById('legal-notice-modal');
    if (!modal || typeof modal.open !== 'function') return;

    evt.preventDefault();

    // Name the dialog after the link that opened it, so screen readers announce
    // whatever wording the merchant used rather than a hardcoded string.
    const label = trigger.textContent.trim();
    const dialog = modal.querySelector('[role="dialog"]');
    if (label && dialog) dialog.setAttribute('aria-label', label);

    modal.open(trigger);
  });

  //点击chat
  const targetElement = document.querySelector('.after-sale-chat-icon');
  if(targetElement) {
    targetElement.addEventListener('click', function() {
      ud("showPanel");
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  document.addEventListener("DOMContentLoaded", (event) => {
    const headerSearchIcon = document.querySelector('.header__icon-search');
    headerSearchIcon.addEventListener('click', (e) => {
      e.preventDefault();
      const searchButton = document.querySelector('.aa-DetachedSearchButton');
      searchButton.click();
    })
  });

  } catch(e) { console.error(e); }
})();
})();
